//noinspection JSUnusedGlobalSymbols
export default {

    all: state => Object.values(state.entities),

    allByOffers: (state, getters) => offers => {
        return offers.map(offer => getters['byId'](offer.variant))
    },

    allByProductId: (state, getters) => productId => {
        return getters['all'].filter(entity => entity.product === productId)
    },

    byId: state => id => {
        return state.entities[id]
    }

}


